import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

// Import controller service
import { ControllerService } from './services/controller/controller.service';

// Import the header component
import { FooterComponent } from './components/footer/footer/footer.component';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Admin';

  constructor(
    public controllerService:ControllerService,
  ){}


  ngOnInit() {
    this.controllerService.initializeApp();
  }

}
